export const setImageUrl = (url) => {
  let mainImageUrl = url?.replace('/view/image/', '');
  if (mainImageUrl?.startsWith('/')) {
    mainImageUrl = mainImageUrl.replace('/', '');
  }
  return process.env.mediaUrl + mainImageUrl;
};
